import '../../../css/fx.scss'
import '../../../css/loading.scss'

import _ from 'lodash'
import {Libs, extension, FX} from 'eyes-lib/es'
import {Translate} from '../../modules/multi-lang'

const {getGlobal} = Libs

/**
 * 全ページで使用する共通ファンクション
 */

/** IE8のpolyfill有効化 */
// extension.ie8()

/** Boolean拡張有効化 */
extension.boolean.val()

/** lodash拡張有効化 */
extension.lodash.basic()

/** jQuery拡張有効化 */
extension.jquery.nvl() //$('#hoge').val()にnvl合わせた機能を有効化
extension.jquery.intVal() //$('#hoge').val()にnvl+toIntを合わせた機能を有効化
extension.jquery.selfHtml() //自身のタグを含めたhtmlタグを取得するプラグイン有効化
extension.jquery.event() //イベント登録を先頭に割り込ませるプラグイン有効化
extension.jquery.disabled() //selectタグをdisable化するプラグイン有効化


/** 画面エフェクト関数 */
const fx = {
	/**
	 * ローディング画面開始
	 * @param {LoadingOption} [options]
	 */
	loadingStart: function(options)
	{
		/** @type {LoadingOption} */
		const opt = _.merge( {
			type: 'spin',
			background: 'rgba(255, 255, 255, 0.76)',
			fade: 600,
		}, options )
		return FX.loadingStart(opt)
	},

	/** ローディング画面停止 */
	loadingEnd: FX.loadingEnd,
}
_.set(getGlobal(), 'fx', fx )

const multiTranslate = _.debounce(function multiTranslate(){

	Translate.setDictionaryPath('/eyeswork/multi/TTT/') // 1. 最後のスラッシュはあってもなくても自動判定で処理します
	const lang = Translate.language.getByURL().toUpperCase() // 2. 言語識別子は言語用ヘルパー関数を使ってください
	
	Translate.apiConfig({url:"http://172.16.21.112:8084/MultiApi/api/multi/multisearch",user:"tin"})// api使用のための初期化

	if((lang != "JP") && (lang!=undefined)){
		const name = 'dom_tour_sys/'+ $("#courseCode").data("courseCode") // 3. 商品コード取得はヘルパー関数にも用意しました
		const option = {
			lang,
			name,
			log:true
		} // 4. コンソールで翻訳内容をコンソールで確認したい場合はtrue（製品ビルドではログ出力されません）


		Promise.resolve().then(()=>{
			Translate.execute(option) // 4.非同期なのでawaitで実行
		})
	}
}, 800)


export {
	fx,
	multiTranslate,
}